import { error as logError, warn as logWarn } from '../utils/logger'
import { apiUrl } from '../config/config'

export const request_get_advanced_team = async ({ authToken }) => {
    const URL = `${apiUrl}/oneapp/advance_team`
    try {
        const response = await fetch(URL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: authToken,
            },
        })
        if (response.ok) {
            const data = await response.json()
            return data.single
        } else {
            logError('AdvanceService', 'Error al realizar la solicitud get_advanced_team')
            return null
        }
    } catch (error) {
    logError('AdvanceService', 'get_advanced_team error', error)
        return null
    }
}

export const request_get_advanced = async ({ authToken , id}) => {
    const URL = `${apiUrl}/oneapp/advance`
    try {
        const response = await fetch(URL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: authToken,
                _id: id
            },
        })
        if (response.ok) {
            const data = await response.json()
            return data.single
        } else {
            logError('AdvanceService', 'Error al realizar la solicitud get_advanced')
            return null
        }
    } catch (error) {
    logError('AdvanceService', 'get_advanced error', error)
        return null
    }
}